<template>
  <v-content v-if="quoteHtml">
    <Header title="Request a callback from the Sales team about your quote" />
    <v-container>
      <v-card>
        <v-card-text>
          <span class="subheading">
            Let us know that you wish to receive a callback about this
            quotation, number:
            <strong>{{ $route.params.quoteId }}</strong> by entering your phone
            number (mobile or landline) and clicking
            <strong>Request Callback</strong>
          </span>
          <br />
          <v-form ref="formCallback" v-model="valid" lazy-validation>
            <v-text-field
              label="Telephone"
              v-model="telephone"
              :rules="telephoneRules"
              outline
            />
            <v-btn
              large
              @click="submitCallback"
              color="info"
              :disabled="clicked"
            >
              <v-icon>call</v-icon>
              <span class="mr-2">Request Callback</span>
            </v-btn>
          </v-form>
          <v-alert :value="feedback" type="error">{{ feedback }}</v-alert>
        </v-card-text>
      </v-card>
      <br />
      <v-alert :value="true" type="info">
        <div v-html="quoteHtml" />
      </v-alert>
      <br />
      <v-card>
        <v-card-text>
          Remember to quote your reference number in any communications and if
          you need to retrieve your quote at any point, it's waiting for you in
          your inbox. Alternatively, click the button if you need to review the
          quotation at any time.
          <br />
          <div>
            <v-btn
              :to="{
                name: 'quotation',
                params: {
                  salesUid: $route.params.salesUid,
                  quoteId: $route.params.quoteId
                }
              }"
            >
              <v-icon>chevron_left</v-icon>
              <span class="mr-2">Review quotation</span>
            </v-btn>
            <v-btn @click="proceed()" color="success">
              <span class="mr-2">Proceed using quote system</span>
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import Header from "@/components/Header";
import nbmlaw from "@/apis/nbmlaw";
export default {
  name: "Callback",
  components: { Header },
  data() {
    return {
      quote: null,
      quoteHtml: null,
      feedback: null,
      valid: false,
      clicked: false,
      telephone: null,
      telephoneRules: [(v) => !!v || "Value is required"]
    };
  },
  methods: {
    async fetchQuote() {
      try {
        const response = await nbmlaw.get(
          `/cors/open/sales/quotes/${this.$route.params.quoteId}`,
          {
            params: { salesUid: this.$route.params.salesUid }
          }
        );
        // console.log(response.data);
        this.quote = response.data;
      } catch (err) {
        console.error(err);
        this.$router.push({ name: "notfound" });
      }
    },
    async fetchQuoteHtml() {
      const response = await nbmlaw.get(
        `/cors/open/sales/quotes/${this.$route.params.quoteId}/htmlSummary`,
        {
          params: { salesUid: this.$route.params.salesUid }
        }
      );
      // console.log(response.data);
      this.quoteHtml = response.data;
    },
    async submitCallback() {
      try {
        if (this.$refs.formCallback.validate()) {
          this.clicked = true;
          const token = await this.$recaptcha("callback");
          await nbmlaw.put(
            `/cors/open/sales/quotes/${this.$route.params.quoteId}/callback`,
            { telephone: this.telephone },
            {
              params: { salesUid: this.$route.params.salesUid, token }
            }
          );
          this.$router.push({
            name: "callbackAcknowledge",
            params: {
              quoteId: this.$route.params.quoteId,
              salesUid: this.$route.params.salesUid
            }
          });
        }
      } catch (err) {
        console.error(err);
        this.feedback = err;
        this.clicked = false;
      }
    },
    proceed() {
      if (!this.quote) {
        return undefined;
      }
      if (this.quote.instructed != 1) {
        this.$router.push({
          name: "instruct",
          params: {
            salesUid: this.$route.params.salesUid,
            quoteId: this.$route.params.quoteId
          }
        });
      } else {
        this.$router.push({
          name: "instructionConfirmation",
          params: {
            salesUid: this.$route.params.salesUid,
            quoteId: this.$route.params.quoteId
          }
        });
      }
    }
  },
  watch: {
    quote: {
      handler() {
        this.telephone = this.quote.telephone;
      }
    }
  },
  created() {
    this.fetchQuote();
    this.fetchQuoteHtml();
  }
};
</script>

<style>
</style>